module.exports = __webpack_public_path__ + "static/media/bp.15e51008.svg";